import './section-detail.less';
import { Image } from 'antd';
import { PSection } from '@/commons/interface/speccommon/section';
import { getSectionTypeItemInfo } from '@/commons/enums/speccommon/section';
import { NumFixed, ParamNameUtil, ParamUnits, Transfer2DisplayScale, convertToSuperscript } from '@/commons/utils/unit';


interface IProps {
    section: PSection
    goBack: (mode: string) => void
    width: number
}

export default function SectionDetail(props: IProps, ref) {



    return (
        <div className='section-detail-panel'>
            <div className='img-area'>
                <Image
                    width={200}
                    height={200}
                    src={getSectionTypeItemInfo(props.section?.type)?.image}
                    preview={false}
                />
            </div>
            <div className='message-area'>
                {Object.keys(props.section?.paramOutGeo ?? {}).map((param: string, idx: number) => {
                    if (param === "max_tw_tf") return null;
                    // 原始值
                    let originValue = props.section?.paramOutGeo[param];
                    // 原始单位
                    let originUnit = ParamUnits[param];
                    // 换算因子
                    let factor = Transfer2DisplayScale(originUnit);
                    // 显示值
                    let displayValue = NumFixed(originValue * factor, 2);
                    return (
                        <div key={idx} className='message' style={{ width: props.width - 32  }}>
                            <div className='param-name'>{ParamNameUtil[param]}:</div>
                            <div className='value'>{displayValue}</div>
                            <div className='unit' dangerouslySetInnerHTML={{ __html: convertToSuperscript(ParamUnits[param]) }} />
                        </div>
                    )
                })}

                {Object.keys(props.section?.paramOutPh ?? {}).map((param: string, idx: number) => {
                    if (param === "max_tw_tf") return null;
                    // 原始值
                    let originValue = props.section?.paramOutPh[param];
                    // 原始单位
                    let originUnit = ParamUnits[param];
                    // 换算因子
                    let factor = Transfer2DisplayScale(originUnit);
                    // 显示值
                    let displayValue = NumFixed(originValue * factor, 2);
                    return (
                        <div key={idx} className='message' style={{ width: props.width - 32  }}>
                            <div className='param-name'>{ParamNameUtil[param]}:</div>
                            <div className='value'>{displayValue}</div>
                            <div className='unit' dangerouslySetInnerHTML={{ __html: convertToSuperscript(ParamUnits[param]) }} />
                        </div>
                    )
                })}
            </div>

        </div>
    )
}